import { clsx } from 'clsx';

import { GridCardFormat } from '~/src/common/components/GridCard/types';
import ImageObjectFit from '~/src/common/components/ImageObjectFit';
import Link from '~/src/common/components/Link';
import { useNiceModal } from '~/src/common/services/ModalsManager';
import Tracker, { CardInfoProperties } from '~/src/common/services/Tracker';
import { CustomContent } from '~/src/common/typings/category';
import { ImageParams } from '~/src/common/typings/image';
import { getLinkProps } from '~/src/common/utils/category/customContent';
import { getImageUrlFromFormat } from '~/src/common/utils/cloudinary';

import sharedStyles from '../_shared-styles.module.scss';

import styles from './MarketingCard.module.scss';

interface Props {
  className?: string;
  customContent: CustomContent;
  analyticsProperties: CardInfoProperties;
  format?: GridCardFormat;
}

const MarketingCard = ({
  customContent,
  className,
  analyticsProperties,
  format = 'card_ratio',
}: Props) => {
  const { show } = useNiceModal('marketing-modal');

  const { link, image, marketingModalId, name } = customContent;

  if (!image) return null;

  const sendClickEvent = () => {
    Tracker.sendEvent('card marketing click', {
      'content name': name,
      'link type': marketingModalId ? 'marketing modal' : 'URL',
      'link': (marketingModalId ? marketingModalId : link) ?? '',
      ...analyticsProperties,
    });
  };

  const imageUrl = getImageUrlFromFormat(image, format, ImageParams.listingCard);

  if (link) {
    const linkProps = getLinkProps(link);
    return (
      <Link {...linkProps}>
        <article
          className={clsx(styles.container, className)}
          style={{
            aspectRatio:
              format === 'square'
                ? sharedStyles['CARD_RATIO-square']
                : sharedStyles['CARD_RATIO-card'],
          }}
          onClick={sendClickEvent}>
          <ImageObjectFit src={imageUrl} alt={image?.alt} className={styles.image} />
        </article>
      </Link>
    );
  }

  return (
    <article
      className={styles.container}
      data-format={format}
      role={marketingModalId ? 'button' : undefined}
      onClick={
        marketingModalId
          ? () => {
              void show({ id: marketingModalId });
              sendClickEvent();
            }
          : undefined
      }>
      <ImageObjectFit src={imageUrl} objectFit="cover" alt={image?.alt} className={styles.image} />
    </article>
  );
};

export default MarketingCard;
